import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { NOT_FOUND_PATH } from 'routes/constants';

interface NumericIdGuardProps {
    paramName?: string | string[]; // defaults to 'id'
    children: React.ReactNode;
}

const isValidNumericId = (value: string | undefined): boolean => {
    if (!value) return true;
    const num = Number(value);
    return !isNaN(num) && Number.isInteger(num) && num > 0;
};

export const NumericIdGuard: React.FC<NumericIdGuardProps> = ({ paramName = 'id', children }) => {
    const params = useParams();
    const navigate = useNavigate();

    const paramNames = Array.isArray(paramName) ? paramName : [paramName];

    const hasInvalidParam = paramNames.some((name) => {
        const value = params[name];
        return value && !isValidNumericId(value);
    });

    // TODO(react-doctor: no-effect-event-handler): route-guard navigation derived
    // from URL params — framework pattern, not a user event.
    useEffect(() => {
        if (hasInvalidParam) {
            navigate(NOT_FOUND_PATH, { replace: true });
        }
    }, [hasInvalidParam, navigate]);

    if (hasInvalidParam) {
        return null;
    }

    return children;
};
